import axios from "axios";
import { createBlobServiceAnonymous } from "azure-storage";
import { HOST_AZURE_STORAGE } from "../constants";

const getConversionRelation = async () => {
  const blobService = createBlobServiceAnonymous(
    process.env.VUE_APP_HOST_NAME_AZURE_STORAGE || HOST_AZURE_STORAGE
  );
  return new Promise((resolve, reject) => {
    blobService.getBlobToText("config", "conversionActions.json", function(
      error,
      text
    ) {
      if (!error) {
        resolve(JSON.parse(text));
      } else {
        reject(error);
      }
    });
  });
};

export const getConversionActions = async (
  customerId,
  businessUnitId,
  fromDate,
  toDate
) => {
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL_GOOGLE}/adwords/convertion-actions/${customerId}/businesses/${businessUnitId}?fromDate=${fromDate}&toDate=${toDate}`
    );
    return data || [];
  } catch (error) {
      return [];
  }
  
  
};

export default getConversionRelation;
